/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Teams_Create_Team_TriggerInputs */



/**
* | output |
* | --- |
* | "New Team" |
*
* @param {Teams_Create_Team_TriggerInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const teams_create_team_trigger = /** @type {((inputs?: Teams_Create_Team_TriggerInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Teams_Create_Team_TriggerInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Neues Team")
	return /** @type {LocalizedString} */ ("New Team")
});